const axios = require("axios");

let api_url = process.env.REACT_APP_API_BASE
if (process.env.REACT_APP_ENV === 'dev') {
  let v = localStorage.getItem("api_url");
  if (v !== null) {
    api_url = v;
  }
}

const instance = axios.create({
  baseURL: api_url,
  responseType: "json",
  headers: {
    "api-access-token": localStorage.getItem("token"),
  },
});

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // quiet: requests that retry by themselves (e.g. polling) handle their errors without alerts
    const quiet = error.config && error.config.quiet;
    if (!error.response) {
      if (!quiet) alert(error);
      return Promise.reject(error);
    }

    switch (error.response.status) {
      case 401:
      case 403:
        // the session expired: log in again, then come back to this page
        if (window.location.pathname !== "/login")
          window.location.replace("/login?next=" + encodeURIComponent(window.location.pathname + window.location.search));
        break;
      case 400:
      case 409:
        break;
      case 500:
        if (quiet) break;
        console.log(error.response);
        window.dispatchEvent(new CustomEvent("axios-error", { detail: "Error "+error.response.status + ": " + (error.response.data?.title || "") }));
        break;
      default:
        if (quiet) break;
        console.log(error.response);
        window.dispatchEvent(new CustomEvent("axios-error", { detail: "Error " + error.response.status + ": " + (error.response.data?.title || error.response.statusText) }));
    }
    return Promise.reject(error);
  }
);

export default instance;
